module.exports = __webpack_public_path__ + "img/image.e3b29bf9.gif";